import { render, staticRenderFns } from "./KasProduksiPintu.vue?vue&type=template&id=6e526780"
import script from "./KasProduksiPintu.vue?vue&type=script&lang=js"
export * from "./KasProduksiPintu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports